import React from "react";
import _ from "underscore"
import { getStoresStats } from "../../actions/stores";
import { getDefaultState, StoresStore } from "../../stores/stores";
import { connect } from "../../utils/aj-react";
import QuickStats from "./quickStats";

export class RetailersGridHeader extends React.Component {

    constructor(props) {
        super(props);
        
        connect(this, StoresStore, getDefaultState());
    }

    componentDidMount(){
        this.getData();
    }

    getData(){
        getStoresStats({  
        })
    }

    render() { 
        const stats = this.state.storesStats ?? [];
        return (
            <QuickStats items={stats}/>
        )
    }
}